function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-puits");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-puits"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(6.000000, 7.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 18,
  height: 15
})), /*#__PURE__*/React.createElement("g", {
  id: "ICONS/\\u2022bg-enjeux",
  transform: "translate(9.000000, 5.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bg-w",
  x: 0,
  y: 0,
  width: 12,
  height: 20
})), /*#__PURE__*/React.createElement("path", {
  d: "M15,3 C21.627417,3 27,8.372583 27,15 C27,21.627417 21.627417,27 15,27 C8.372583,27 3,21.627417 3,15 C3,8.372583 8.372583,3 15,3 Z M15,6 C10.0294373,6 6,10.0294373 6,15 C6,17.1202272 6.73315886,19.069216 7.95978562,20.6072754 C7.04010661,19.3052948 6.5,17.7157217 6.5,16 C6.5,11.581722 10.081722,8 14.5,8 C18.918278,8 22.5,11.581722 22.5,16 C22.5,20.418278 18.918278,24 14.5,24 L14.7425913,23.9963897 C14.8281012,23.9987912 14.9139094,24 15,24 C19.9705627,24 24,19.9705627 24,15 C24,10.0294373 19.9705627,6 15,6 Z",
  id: "Combined-Shape",
  fill: "#000000"
})));

const SvgIco30Puits = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Puits, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-puits.b5a386c5.svg";
export { ForwardRef as ReactComponent };